export default "/static/build/main-mobile.webp";